
// @ts-nocheck

import { Vue, Prop, Component } from 'vue-property-decorator'
import { checkIfEmailAddressIsValid } from '@/utils/email'

@Component({
	//
})
export default class EmailForm extends Vue {
	@Prop({ required: true })
	type!: string

	@Prop({ required: false, default: '' })
	filename!: string

	@Prop({ required: false, default: '' })
	defaultFrom!: string

	@Prop({ required: false, default: '' })
	defaultReplyTo!: string

	@Prop({ required: false, default: '' })
	defaultReceiver!: string

	@Prop({ required: false, default: '' })
	defaultSubject!: string

	@Prop({ required: false, default: '' })
	defaultBody!: string

	@Prop({ required: false, default: false })
	senderEditable!: boolean

	send: boolean = true
	from: string = ''
	replyTo: string = ''
	receivers: Array<string> = []
	subject: string = ''
	body: string = ''
	sendCopy: boolean = false

	async created() {
		this.from = this.defaultFrom
		this.replyTo = this.defaultReplyTo
		this.subject = this.defaultSubject
		this.body = this.defaultBody
		if (this.defaultReceiver) {
			this.receivers = [this.defaultReceiver || ''].filter(Boolean)
		}
	}

	get receiversNotValidErrorMessage(): Array<string> {
		if (!this.receivers.length) return []
		return this.receivers
			.map((emailAddress) => {
				if (!checkIfEmailAddressIsValid(emailAddress)) {
					return this.$t('emailDialog.invalid_email', {
						email: emailAddress
					}) as string
				}
				return ''
			})
			.filter(Boolean)
	}
}
